// extracted by mini-css-extract-plugin
export var copyableField = "_qk-4";
export var customerBadge = "_qk-0";
export var customerInfoTitle = "_qk-2";
export var details = "_qk-1";
export var dropdownContainer = "_qk-5";
export var dropdownImage = "_qk-6";
export var editAssigneeForm = "_qk-a";
export var editButton = "_qk-3";
export var email = "_qk-7";
export var hidden = "_qk-d";
export var input = "_qk-8";
export var saveButton = "_qk-b";
export var shopifyIcon = "_qk-c";
export var suggestionBadge = "_qk-e";
export var suggestionText = "_qk-f";
export var username = "_qk-9";